// https://cookieconsent.orestbida.com

//import * as CookieConsent from 'vanilla-cookieconsent';
import {run} from 'vanilla-cookieconsent';

// Ajouter un service dans le markup HTML:
// <script type="textplain" data-category="analytics" data-service="ga">Code GA ici</script>
// NOTE: textplain au lieu de text/plain: ça fonctionne idem et évite l'erreur parcel qui ne doit pas apprécier le "/"

// Enable dark mode
//document.documentElement.classList.add('cc--darkmode');

run({
    cookie: {
	useLocalStorage: true	    // Juste pour éviter des collisions entre vitroto.fr et {dev,test}.vitroto.fr
    },
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom left",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
	    // Défaut: enabled false, readonly false
            readOnly: true
        },
	/*
        analytics: {
	    // Exemple, à adapter, ici en config / catégorie, donc pas de réglage fin
	    autoClear: {
		cookies: [
		    { name: /^(_ga)/ },
		    { name: /^(_gid)/ },
		]
	    },
	    services: {
		ga: {
		    label: 'Google Analytics',
		    onAccept: () => {
			console.log('Google Analytics ACCEPTÉ');
		    },
		    onReject: () => {
			// Déclenché uniquement sur un rejet lorsque le cookie est préalablement accepté
			console.log('Google Analytics REJETÉ');
		    },
		    cookies: [
			{name: /^(_ga|_gid)/},		// À adapter si on utilise
		    ]
		},
		new_service: {
		    label: 'Un autre service',
		    onAccept: () => {
			console.log('Un autre service ACCEPTÉ');
		    },
		    onReject: () => {
			console.log('Un autre service REJETÉ');
		    }
		}
	    }
	}
	*/
    },
    language: {
        default: "fr",
        translations: {
            fr: {
                consentModal: {
		    title: '🍪 Nous utilisons des cookies !',
                    description: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site, mesurer l’audience et vous proposer des contenus adaptés à vos préférences. En cliquant sur « Accepter », vous consentez à leur utilisation.',
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    showPreferencesBtn: "Gérer les préférences",
                    footer: "<a href=\"/politique-de-confidentialite\">Politique de confidentialité</a>\n<a href=\"/cgv\">Termes et conditions</a>"
                },
                preferencesModal: {
                    title: "Préférences des cookies",
                    acceptAllBtn: "Tout accepter",
                    acceptNecessaryBtn: "Tout rejeter",
                    savePreferencesBtn: "Sauvegarder les préférences",
                    closeIconLabel: "Fermer la modale",
                    serviceCounterLabel: "Services",
                    sections: [



                        {
                            title: 'Personnalisez vos préférences de cookies 🍪',
                            description: 'Vous pouvez choisir les catégories de cookies que vous souhaitez autoriser ou refuser. Les cookies nécessaires assurent le fonctionnement du site et ne peuvent pas être désactivés. Sélectionnez ci-dessous vos préférences puis cliquez sur « Sauvegarder les préférences ».'
                        },
                        {
                            title: "Cookies Strictement Nécessaires <span class=\"pm__badge\">Toujours Activé</span>",
                            description: "Ce site utilise un cookie de session, un cookie pour se rappeler de vous et enregistre les presents choix en matière de cookies dans le localStorage, aucune de ces informations n'est identifiante.",
                            linkedCategory: "necessary"
                        },
			/*
                        {
                            title: "Cookies Analytiques",
                            description: "Ces cookies permettent d'analyser le comportement général des utilisateurs du site.",
                            linkedCategory: "analytics",
			    cookieTable: {
                                headers: {
                                    name: "Nom",
                                    domain: "Service",
                                    description: "Description",
                                    expiration: "Expiration"
                                },
                                body: [
                                    {
                                        name: "_ga",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Expire après 12 jours"
                                    },
                                    {
                                        name: "_gid",
                                        domain: "Google Analytics",
                                        description: "Cookie mis en place par <a href=\"#das\">Google Analytics</a>",
                                        expiration: "Session"
                                    }
                                ]
                            }
                        },
			*/
                        {
                            title: "Plus d'informations",
			    // Todo: quand la page contact sera implémentée, ajouter le lien, ex:
			    //<a class=\"cc__link\" href=\"/contact\">contact me</a>
                            description: "Pour toute demande en relation avec la politique cookies et vos choix, veuillez nous contacter via le formulaire de contact."
                        }
                    ]
                }
            }
        }
    }
});
